import { Show, useContext, Suspense, SuspenseList } from "solid-js";
import { AppControllerContext } from "./AppControllerContext";
import { LogOutIcon } from "./LogOutIcon";
import { Loading } from "./Loading";
import { Footer } from "./Footer";
// Example taken from https://docs.solidjs.com/solid-router/concepts/layouts
export function BareLayout(props) {
    const appController = useContext(AppControllerContext);
    if (appController) {
        return (<div id="bare-layout-container" style="display: grid;">
                <SuspenseList revealOrder="forwards">
                    <header id="layout-top-bar" class="full-screen-sticky-header" style={`display: flex; flex-wrap: wrap; gap: 3rem; padding: 2rem; align-items: center; ${props.background ? `background: ${props.background}` : ""};`}>
                        <Show when={props.additionalHeaderLeftChildren}>
                            {props.additionalHeaderLeftChildren}
                        </Show>
                        <Suspense fallback={<Loading resourceName="profile"/>}>
                            <div id="userDetailsContainer" style="display: flex; gap: 2rem; align-items: center; margin-left: auto;" title={appController.userSession.getAccount()?.name}>
                                <span><LogOutIcon /></span>
                                <div style="margin-left: auto; color: #fff; font-size: var(--emsurge-marketplace-medium-font-size); cursor: pointer;" onclick={appController.logOut}>
                                    Log Out
                                </div>
                                {props.additionalHeaderRightChildren}
                            </div>
                        </Suspense>
                    </header>
                    <main class="full-screen-app-main-content-container" style="display: flex; justify-content: center; flex-direction: column;">
                        {props.children}
                    </main>
                    <Footer />
                </SuspenseList>
            </div>);
    }
    else {
        throw "appControllerContext is undefined!";
    }
}
